<ion-grid class="ion-padding ion-no-margin">
    <ion-row class="ion-align-items-center">
        <ion-col class="modal__left-col" size="1">
            <h2><ion-icon name="{{ icon || 'alert-circle-outline' }}"></ion-icon></h2>
        </ion-col>
        <ion-col class="modal__right-col" size="11">
            <h2>{{ header }}</h2>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col class="modal__left-col" size="1">&nbsp;</ion-col>
        <ion-col class="modal__right-col" size="11">
            <div class="modal__message"
                 [innerHTML]="sanitizer.bypassSecurityTrustHtml(message)"></div>
        </ion-col>
    </ion-row>
    <ion-row class="ion-padding modal__buttons">
        <ion-button (click)="dismiss()"
                    shape="round"
                    strong="true">{{ buttonText || 'Okay' }}</ion-button>
    </ion-row>
</ion-grid>
